import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/ApiServiceProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/globals.scss");
import(/* webpackMode: "eager" */ "/app/src/components/LanguageInitiator.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/layout/Footer.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/layout/Header.tsx");
import(/* webpackMode: "eager" */ "/app/src/providers/SharedDataProvider.tsx")